/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tournaments_Calendar_CopiedInputs */



/**
* | output |
* | --- |
* | "Copied!" |
*
* @param {Tournaments_Calendar_CopiedInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const tournaments_calendar_copied = /** @type {((inputs?: Tournaments_Calendar_CopiedInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tournaments_Calendar_CopiedInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Copié !")
	if (locale === "es") return /** @type {LocalizedString} */ ("¡Copiado!")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Copiado!")
	if (locale === "it") return /** @type {LocalizedString} */ ("Copiato!")
	return /** @type {LocalizedString} */ ("Copied!")
});